import { useMemo, useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import {
  PROD_NEEDED_FULL_PALLET,
  isValidProdNumber,
  parseProdNeeded,
} from "../utils/prodNeeded";
import { ModalShell } from "./ModalShell";

export function ProdNeededModal({ item, onCancel, onSave }) {
  const parsed = useMemo(() => parseProdNeeded(item.prod_needed), [item.prod_needed]);
  const [mode, setMode] = useState(parsed.mode);
  const [partialRows, setPartialRows] = useState(parsed.partialRows);
  const [estimateLow, setEstimateLow] = useState(parsed.estimateLow);
  const [estimateHigh, setEstimateHigh] = useState(parsed.estimateHigh);
  const [count, setCount] = useState(parsed.count);

  const estimateLowNumber = Number(estimateLow);
  const estimateHighNumber = Number(estimateHigh);
  const validPartial = mode !== "partial" || isValidProdNumber(partialRows);
  const validEstimate =
    mode !== "estimate" ||
    (isValidProdNumber(estimateLow) &&
      isValidProdNumber(estimateHigh) &&
      estimateLowNumber <= estimateHighNumber);
  const validCount = mode !== "count" || isValidProdNumber(count);
  const saveDisabled = !validPartial || !validEstimate || !validCount;

  const getValue = () => {
    if (mode === "full") {
      return PROD_NEEDED_FULL_PALLET;
    }
    if (mode === "partial") {
      return String(Number(partialRows));
    }
    if (mode === "count") {
      return `COUNT:${Number(count)}`;
    }
    return `${Number(estimateLow)}-${Number(estimateHigh)}`;
  };

  return (
    <ModalShell
      icon={<Inventory2OutlinedIcon />}
      title="Prod Needed"
      subtitle={item.item_name}
      onClose={onCancel}
    >
      <div className="prod-needed-modes" role="group" aria-label="Prod Needed type">
        <button
          type="button"
          className={`segmented-button ${mode === "full" ? "active" : ""}`}
          aria-pressed={mode === "full"}
          onClick={() => setMode("full")}
        >
          Full Pallet (FP)
        </button>
        <button
          type="button"
          className={`segmented-button ${mode === "partial" ? "active" : ""}`}
          aria-pressed={mode === "partial"}
          onClick={() => setMode("partial")}
        >
          Partial X
        </button>
        <button
          type="button"
          className={`segmented-button ${mode === "estimate" ? "active" : ""}`}
          aria-pressed={mode === "estimate"}
          onClick={() => setMode("estimate")}
        >
          Estimate X-X
        </button>
        <button
          type="button"
          className={`segmented-button ${mode === "count" ? "active" : ""}`}
          aria-pressed={mode === "count"}
          onClick={() => setMode("count")}
        >
          Count X
        </button>
      </div>

      {mode === "partial" && (
        <div className="modal-field">
          <label htmlFor="prod-needed-partial">Rows needed</label>
          <input
            id="prod-needed-partial"
            type="number"
            min="1"
            max="99"
            value={partialRows}
            onChange={(event) => setPartialRows(event.target.value)}
          />
        </div>
      )}

      {mode === "estimate" && (
        <div className="modal-field">
          <label>Estimated rows</label>
          <div className="range-inputs">
            <input
              aria-label="Estimate low"
              type="number"
              min="1"
              max="99"
              value={estimateLow}
              onChange={(event) => setEstimateLow(event.target.value)}
            />
            <input
              aria-label="Estimate high"
              type="number"
              min="1"
              max="99"
              value={estimateHigh}
              onChange={(event) => setEstimateHigh(event.target.value)}
            />
          </div>
        </div>
      )}

      {mode === "count" && (
        <div className="modal-field">
          <label htmlFor="prod-needed-count">Individual count</label>
          <input
            id="prod-needed-count"
            type="number"
            min="1"
            max="99"
            value={count}
            onChange={(event) => setCount(event.target.value)}
          />
        </div>
      )}

      <div className="modal-actions">
        <button type="button" className="touch-button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="touch-button danger"
          onClick={() => onSave(null)}
          disabled={!item.prod_needed}
        >
          Clear
        </button>
        <button
          type="button"
          className="touch-button"
          onClick={() => onSave(getValue())}
          disabled={saveDisabled}
        >
          Save
        </button>
      </div>
    </ModalShell>
  );
}
